import React, { useEffect, useRef, useState } from 'react';
import withRipple from 'jd-library/withRipple';
import styles from './user_auth.scss';

const ListElem = props => {
	return (
        <>
            <div className={styles['list-elem']+' '+props.rippleClass} onClick={props.onClick} {...props.rippleHandler}>
                <div>{props.content}</div>
                <div className='icon-Next next-icon'></div>
                {props.renderRipple()}
            </div>
            <div className={styles['divider']+' '+styles['list-elem-divider']}></div>
        </>
	);
};

export default withRipple(ListElem);
